import { useEffect, useState } from "react";
import { SOUND_GROUPS, sounds, type SoundGroup } from "./sounds";

/* React view of the sound settings, so the top bar and Settings stay in step */

const SOUND_EVENT = "aynjel:sound";

const snapshot = () => ({
  enabled: sounds.isEnabled(),
  volume: sounds.getVolume(),
  groups: Object.fromEntries(SOUND_GROUPS.map((g) => [g.id, sounds.isGroupOn(g.id)])) as Record<
    SoundGroup,
    boolean
  >,
});

const changed = () => window.dispatchEvent(new Event(SOUND_EVENT));

/* Turning on answers with a rising pair; turning off plays the falling pair before going quiet */
export function setSoundOn(on: boolean) {
  if (on) {
    sounds.setEnabled(true);
    sounds.play("think");
  } else {
    sounds.play("unthink");
    sounds.setEnabled(false);
  }
  changed();
}

export function setSoundGroup(group: SoundGroup, on: boolean) {
  sounds.setGroupOn(group, on);
  changed();
}

export function setSoundVolume(volume: number) {
  sounds.setVolume(volume);
  changed();
}

export function useSound() {
  const [state, setState] = useState(snapshot);

  useEffect(() => {
    const update = () => setState(snapshot());
    window.addEventListener(SOUND_EVENT, update);
    // sounds.ts reloads its own settings on "storage"; read them after it has
    const onStorage = () => window.setTimeout(update, 0);
    window.addEventListener("storage", onStorage);
    return () => {
      window.removeEventListener(SOUND_EVENT, update);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  return state;
}
